export default __webpack_public_path__ + "static/media/mirjam02.1dbdec86.png";